import React from 'react';
import Cookies from 'js-cookie';

const CertificadoDisplay = ({ items, mapping }) => {

    if (items != null) {
      return (
        <>
        
          {items.map((item, index) => {
    return (
      <tr key={item.id} className="cewyTableRow">
          <td className="cewyTableCell">
            <button
              type="button"
              className="cewyBrandName "
              onClick={() => {
                localStorage.setItem('certificado', JSON.stringify(item));  
                window.location.href = `${mapping}/toolMenu?certificadoId=${item.id}&certificadoName=${item.certificado}`;
              }}
            >
              {item.certificado}
            </button>
          </td>
        </tr>
  
    );
  })}
        </>
      );
    }
  }
  
  export default CertificadoDisplay; 